import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from '../../App/routes';

export const portalsRoot = 'portals';
export const pluginsQuery = '?tab=Plugins';

export const portalsOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${portalsRoot}`;

export const pluginsTabRoute = `${portalsOverviewRoute}${pluginsQuery}`;
